export enum DropOffLocation {
  ATTENDED_DELIVERY = 'ATTENDED_DELIVERY',
  BEHIND_GARBAGE_BIN = 'BEHIND_GARBAGE_BIN',
  BICYCLE_BASKET = 'BICYCLE_BASKET',
  DOORSTEP = 'DOORSTEP',
  FRONT_DOOR = 'FRONT_DOOR',
  GARAGE = 'GARAGE',
  GARDEN = 'GARDEN',
  GAS_METER = 'GAS_METER',
  GREENHOUSE = 'GREENHOUSE',
  INSIDE_BOX = 'INSIDE_BOX',
  INSIDE_CAR = 'INSIDE_CAR',
  INSIDE_HOME = 'INSIDE_HOME',
  LOCKER = 'LOCKER',
  MAIL_ROOM_OR_SLOT = 'MAIL_ROOM_OR_SLOT',
  NEIGHBOR = 'NEIGHBOR',
  PICKUP_POINT = 'PICKUP_POINT',
  PORCH = 'PORCH',
  PROPERTY_OFFICE = 'PROPERTY_OFFICE',
  REAR_DOOR = 'REAR_DOOR',
  RECEPTIONIST = 'RECEPTIONIST',
  SECURITY = 'SECURITY',
  SHED = 'SHED',
  SIDE_PORCH = 'SIDE_PORCH',
  STORE = 'STORE',
  TERRACE = 'TERRACE',
  UNKNOWN = 'UNKNOWN'
}

const PACKAGE_DROPOFF_LOCATION_PREFIX = 'swiship_dropoff_location_';

const dropOffLocationMap: Map<string, DropOffLocation> = new Map([
  ['ATTENDED_DELIVERY', DropOffLocation.ATTENDED_DELIVERY],
  ['BEHIND_GARBAGE_BIN', DropOffLocation.BEHIND_GARBAGE_BIN],
  ['BICYCLE_BASKET', DropOffLocation.BICYCLE_BASKET],
  ['DOORSTEP', DropOffLocation.DOORSTEP],
  ['FRONT_DOOR', DropOffLocation.FRONT_DOOR],
  ['GARAGE', DropOffLocation.GARAGE],
  ['GARDEN', DropOffLocation.GARDEN],
  ['GAS_METER', DropOffLocation.GAS_METER],
  ['GREENHOUSE', DropOffLocation.GREENHOUSE],
  ['INSIDE_BOX', DropOffLocation.INSIDE_BOX],
  ['INSIDE_CAR', DropOffLocation.INSIDE_CAR],
  ['INSIDE_HOME', DropOffLocation.INSIDE_HOME],
  ['LOCKER', DropOffLocation.LOCKER],
  ['MAIL_ROOM_OR_SLOT', DropOffLocation.MAIL_ROOM_OR_SLOT],
  ['NEIGHBOR', DropOffLocation.NEIGHBOR],
  ['PICKUP_POINT', DropOffLocation.PICKUP_POINT],
  ['PORCH', DropOffLocation.PORCH],
  ['PROPERTY_OFFICE', DropOffLocation.PROPERTY_OFFICE],
  ['REAR_DOOR', DropOffLocation.REAR_DOOR],
  ['RECEPTIONIST', DropOffLocation.RECEPTIONIST],
  ['SECURITY', DropOffLocation.SECURITY],
  ['SHED', DropOffLocation.SHED],
  ['SIDE_PORCH', DropOffLocation.SIDE_PORCH],
  ['STORE', DropOffLocation.STORE],
  ['TERRACE', DropOffLocation.TERRACE],
  ['UNKNOWN', DropOffLocation.UNKNOWN]
]);

export const getDropOffLocation = (locationString: string): DropOffLocation => {
  return dropOffLocationMap.get(locationString) || DropOffLocation.UNKNOWN;
};

export const toSwishipString = (location: DropOffLocation): string => {
  return PACKAGE_DROPOFF_LOCATION_PREFIX + location.toLowerCase();
};

export const getRecipientMessage = (
  dropOffLocation: DropOffLocation,
  recipientName?: string,
  recipientDoorNumber?: string
): string | null => {
  if (dropOffLocation === DropOffLocation.RECEPTIONIST) {
    return recipientName 
      ? `swiship_delivered_to_receptionist_with_name`
      : `swiship_delivered_to_receptionist`;
  } else if (dropOffLocation === DropOffLocation.NEIGHBOR) {
    if (recipientName && recipientDoorNumber) {
      return `swiship_delivered_to_neighbor_with_name_and_door`;
    } else if (recipientName) {
      return `swiship_delivered_to_neighbor_with_name`;
    } else if (recipientDoorNumber) {
      return `swiship_delivered_to_neighbor_with_door`;
    }
  }
  return null;
};
